import { useTenantTranslation } from "hooks/formatters";
import { useCallback } from "react";

export const useFormatVersionLabel = () => {
  const { t } = useTenantTranslation();
  return useCallback(
    (versionNumber: number) => `${t("version")} ${versionNumber}`,
    [t]
  );
};
